export class Event {
    static events: { [EventName: string]: Function[] } = {};
    static on(eventName: string, callback: Function) {
        if (!Event.events[eventName]) {
            Event.events[eventName] = [callback];
        } else {
            Event.events[eventName].push(callback);
        }
    }

    static trigger(eventName: string, data?: any) {
        //Don't trigger if there are no listeners
        if (Event.events[eventName]) {
            Event.events[eventName].forEach(callback => {
                if (data !== undefined) {
                    callback(data);
                    return
                }
                callback();
            });
        }
    }
}

// Events.on("emailValid", checkAllValid)
// Events.on("phoneValid", checkAllValid)
// Events.on("addressValid", checkAllValid)